import { render, staticRenderFns } from "./exclusiveWelfare.vue?vue&type=template&id=25ca59a7&scoped=true&"
import script from "./exclusiveWelfare.vue?vue&type=script&lang=js&"
export * from "./exclusiveWelfare.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveWelfare.vue?vue&type=style&index=0&id=25ca59a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca59a7",
  null
  
)

export default component.exports